// LIBRERIE
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//Componenti
import MagicCarousel from "../GraphicElements/MagicCarousel";


const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return(
        <section id="presentation" className="space-ptb bg-white">
            <div className="container-fluid w-85">
                <div className="row align-items-center justify-content-center">
                    <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                        <h2>{t('homePage.presentation.title')}</h2>
                        <p className="sub-title mb-4">{t('homePage.presentation.subTitle')}</p>
                        <p dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text1') as string }}></p>
                        <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.presentation.text2') as string }}></p>
                        <Link to={'/chi-siamo'} className="btn btn-primary">
                            <span>{t('homePage.presentation.btnText')}</span>    
                        </Link>
                    </div>
                    <div className="col-12 col-lg-6 text-center">
                        <MagicCarousel />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;